enum ObservationTypes {
  GENERAL = 'General',
  COURSE = 'Asignatura',
}

const typesObservations = [
  {
    id: 'GENERAL',
    name: ObservationTypes.GENERAL,
  },
  {
    id: 'COURSE',
    name: ObservationTypes.COURSE,
  },
];

export { ObservationTypes, typesObservations };
